// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"EwRwPB","input":"QiGIB8"};